import DateTimeHandlerService from "@/services/common/date-time/DateTimeHandlerService";

const getters = {
	userOffset: (state) =>
	{
		let offset = "00:00";
		if (state.userPreferences.timeZone.name.length > 0)
		{
			offset = DateTimeHandlerService.GetOffsetValueFromString(state.userPreferences.timeZone.name);
		}
		return offset;
	},
	userLanguage:    (state) => state.userPreferences.language,
	userPreferences: (state) => state.userPreferences,
};
export default { getters };
